import React from 'react';
import { Helmet } from 'react-helmet-async';

type MetaTagsProps = {
  title?: string;
  author?: string;
  description?: string;
  keywords?: string[];
};
const MetaTags = ({
  title = "Theo's Bistro",
  author = "Theo's Bistro",
  description = "Admin page für Theo's Bistro",
  keywords = [],
}: MetaTagsProps) => {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <link rel="canonical" href={window.location.href} />
      <meta name="description" content={description} />
      <link rel="icon" href={`${window.location.hostname}/favicon.ico`} />
      <meta name="keywords" content={keywords.join(', ')} />
      <meta name="author" content={author} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <link
        rel="apple-touch-icon"
        href={`${window.location.hostname}/logo.png`}
      />
      <link rel="manifest" href={`${window.location.hostname}/manifest.json`} />
    </Helmet>
  );
};

export default MetaTags;
